import React from 'react';
import { Brain, CalendarCheck, ChevronRight, Mic, Target } from 'lucide-react';
import { ProgressBar, cn } from '../../../ui';
import IconChip from '../shared/IconChip';
import TileLink from '../shared/TileLink';

const TILE_ICONS = { progress: Target, attendance: CalendarCheck, ai: Brain, mock: Mic };

const BAR_COLORS = { violet: 'violet', emerald: 'emerald', sky: 'info', amber: 'amber', rose: 'rose' };

const SUB_INK = {
  emerald: 'tw-text-success-fg',
  sky: 'tw-text-info-fg',
  amber: 'tw-text-warning-fg',
};

const StatTile = ({ tile, className }) => {
  const standing = tile.standing || tile.tone;
  return (
    <TileLink
      to={tile.to}
      className={cn(
        'tw-flex tw-min-w-0 tw-flex-col tw-rounded-lg tw-border tw-border-solid tw-border-line tw-bg-surface-raised',
        'tw-p-3 tw-shadow-card page-sm:tw-px-4 page-sm:tw-py-3.5',
        className,
      )}
    >
      <div className="tw-flex tw-items-center tw-gap-2">
        <IconChip icon={TILE_ICONS[tile.key]} tone={tile.tone} round size={30} className="page-lg:tw-h-[34px] page-lg:tw-w-[34px]" />
        <span className="tw-min-w-0 tw-flex-1 tw-text-xs tw-font-semibold tw-leading-tight tw-text-content-muted">{tile.title}</span>
        <ChevronRight size={16} aria-hidden="true" className="tw-hidden tw-shrink-0 tw-text-content-subtle page-lg:tw-block" />
      </div>
      <div className="tw-mt-2.5 tw-text-[1.375rem] tw-font-medium tw-leading-none page-lg:tw-text-[1.625rem]">
        {tile.value}
        {tile.suffix && <span className="tw-ml-1 tw-text-sm tw-font-semibold tw-text-content-subtle">{tile.suffix}</span>}
      </div>
      {typeof tile.progress === 'number' && (
        <ProgressBar value={tile.progress} size="md" color={BAR_COLORS[standing] || 'primary'} className="tw-mt-2.5" />
      )}
      {tile.sub && (
        <div className={cn('tw-mt-2 tw-text-xs tw-font-semibold tw-text-content-subtle', SUB_INK[standing])}>
          {tile.sub}
        </div>
      )}
    </TileLink>
  );
};

/** Two across on a phone, one row once they fit. A smaller plan's tiles fill the same width. */
const StatTiles = ({ tiles }) => (
  <div className="tw-grid tw-grid-cols-2 tw-gap-3 page-sm:tw-gap-4 page-md:tw-grid-cols-none page-md:tw-grid-flow-col page-md:tw-auto-cols-fr">
    {tiles.map((tile, i) => {
      const leftOver = tiles.length % 2 === 1 && i === tiles.length - 1;
      return <StatTile key={tile.key} tile={tile} className={leftOver ? 'tw-col-span-2 page-md:tw-col-span-1' : ''} />;
    })}
  </div>
);

export default StatTiles;
